import authenticate from '../src/ns-api/authenticate/authenticate';
import deleteAudio from '../src/ns-api/deleteAudio/deleteAudio';
import getDialPlan from '../src/ns-api/getDialPlan/getDialPlan';
import getDialRule from '../src/ns-api/getDialRule/getDialRule';
import getLanguages from '../src/voice-api/getLanguages/getLanguages';
import getVoices from '../src/voice-api/getVoices/getVoices';
import normalizeLanguageCode from '../src/utils/normalizeLanguageCode/normalizeLanguageCode';
import normalizeLanguageCodes from '../src/utils/normalizeLanguageCodes/normalizeLanguageCodes';
import postAnswerRule from '../src/ns-api/postAnswerRule/postAnswerRule';
import postDialRule from '../src/ns-api/postDialRule/postDialRule';
import getTranscriptionIntelligence from '../src/ns-api/getTranscriptionIntelligence/getTranscriptionIntelligence';
import getTranscriptionJob from '../src/ns-api/getTranscriptionJob/getTranscriptionJob';
import getTranscriptions from '../src/ns-api/getTranscriptions/getTranscriptions';
import saveAudio from '../src/ns-api/saveAudio/saveAudio';
import synthesize from '../src/voice-api/synthesize/synthesize';

export default {
  authenticate,
  deleteAudio,
  getDialPlan,
  getDialRule,
  getLanguages,
  getVoices,
  normalizeLanguageCode,
  normalizeLanguageCodes,
  postAnswerRule,
  postDialRule,
  getTranscriptionIntelligence,
  getTranscriptionJob,
  getTranscriptions,
  saveAudio,
  synthesize,
};
